"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var toLower_1 = __importDefault(require("lodash/toLower"));
var EnvUtil = /** @class */ (function () {
    function EnvUtil() {
    }
    Object.defineProperty(EnvUtil, "isApp", {
        get: function () {
            try {
                return !!(window && window.location);
            }
            catch (e) {
                return false;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EnvUtil, "isNode", {
        get: function () {
            try {
                return !!(process && process.env);
            }
            catch (e) {
                return false;
            }
        },
        enumerable: true,
        configurable: true
    });
    EnvUtil.getAppEnv = function () {
        if (EnvUtil.isApp) {
            var domain = window.location.hostname;
            if (domain) {
                domain = domain.toLowerCase();
                if (domain.match(/local/)) {
                    return EnvUtil.ENV_LOCAL;
                }
                if (domain.match(/test2/)) {
                    return EnvUtil.ENV_TEST_2;
                }
                if (domain.match(/test/)) {
                    return EnvUtil.ENV_TEST;
                }
                if (domain.match(/stg/)) {
                    return EnvUtil.ENV_STG;
                }
                if (domain.match(/storybook/)) {
                    return EnvUtil.ENV_STORYBOOK;
                }
                return EnvUtil.ENV_PROD;
            }
        }
        return undefined;
    };
    EnvUtil.getNodeEnv = function () {
        if (EnvUtil.isNode) {
            return toLower_1.default(process.env.NODE_ENV);
        }
        return undefined;
    };
    /**
     * Main method to check on the current env.
     * May be extended to check on the currency NODE JS env.
     * @returns {*}
     */
    EnvUtil.getEnv = function () {
        return EnvUtil.getAppEnv() || EnvUtil.getNodeEnv();
    };
    Object.defineProperty(EnvUtil, "isProd", {
        get: function () {
            return EnvUtil.ENV_PROD === EnvUtil.getEnv();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EnvUtil, "isStg", {
        get: function () {
            return EnvUtil.ENV_STG === EnvUtil.getEnv();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EnvUtil, "isTest", {
        get: function () {
            return EnvUtil.ENV_TEST === EnvUtil.getEnv();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EnvUtil, "isTest2", {
        get: function () {
            return EnvUtil.ENV_TEST_2 === EnvUtil.getEnv();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EnvUtil, "isLocal", {
        get: function () {
            return EnvUtil.ENV_LOCAL === EnvUtil.getEnv();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EnvUtil, "isCI", {
        get: function () {
            return !!process.env.CI;
        },
        enumerable: true,
        configurable: true
    });
    EnvUtil.ENV_LOCAL = 'local';
    EnvUtil.ENV_TEST = 'test';
    EnvUtil.ENV_TEST_2 = 'test2';
    EnvUtil.ENV_STG = 'staging';
    EnvUtil.ENV_PROD = 'production';
    EnvUtil.ENV_STORYBOOK = 'storybook';
    return EnvUtil;
}());
exports.EnvUtil = EnvUtil;
exports.default = EnvUtil;
//# sourceMappingURL=EnvUtil.js.map